import Form from 'react-bootstrap/Form';
import { FormSectionWrapper } from './FormSectionWrapper';
import { SpecialServices } from "./SpecialServices"
import { signatureOptions } from '../utils/dropdownOptions';

export const Options = ({ formik, isReturnShipmentTab }) => {
    const values = isReturnShipmentTab ? formik.values.returnData : formik.values;
    const isMps = values.mpsPackages.length > 0;

    return (
        <>
            <SpecialServices formik={formik} shortcuts={false} isReturnShipmentTab={isReturnShipmentTab} />
            <FormSectionWrapper title='Signature Options'>
                {isMps ? 'Please select Signature Options on the Multiple-piece Shipment dialog' :
                    <Form.Group className='form-group'>
                        <Form.Label>Signature options</Form.Label>
                        <Form.Select
                            id={isReturnShipmentTab ? 'returnData.signatureOption' : 'signatureOption'}
                            {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.signatureOption' : 'signatureOption')}
                        >
                            {
                                signatureOptions.map((i) => (
                                    <option key={i.value} value={i.value}>{i.key}</option>
                                ))
                            }
                        </Form.Select>
                    </Form.Group>
                }
            </FormSectionWrapper>
        </>
    )
}